import * as React from "react";
import { connect } from "react-redux";

import {
  BackToHousehold,
  DisclosureModal,
  PortfolioHistoryModal,
  SubNav,
} from "..";
import withStyles from "@material-ui/core/styles/withStyles";
import {withRouter} from "react-router-dom";

const styles = (theme) => ({
  bottomLink: {
    background: "transparent",
    color: theme.palette.grey[600],
    cursor: "pointer",
    fontSize: 14,
    height: "auto",
    position: "absolute",
    top: "auto",
    left: 25,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
      paddingLeft: 25,
      bottom: 13,
    },
    [theme.breakpoints.down("lg")]: {
      left: 0,
      width: '100%',
      textAlign: 'center',
      fontSize: 13
    },
    "&.disclosure": {
      bottom: 40,
    },
    "&.history": {
      bottom: 80,
    },
  },
});

function DoNavigation({
   app,
   pathname,
   open,
   currentPortfolio,
   location,
   classes,
 }) {
  let portfolioId = currentPortfolio && currentPortfolio.uuid;
  let householdId = currentPortfolio && currentPortfolio.Household.id;
  const predecessorPortfolioId =
    currentPortfolio && currentPortfolio.predecessorPortfolioId;
  const successorPortfolioId =
    currentPortfolio && currentPortfolio.successorPortfolioId;
  const pathItems = location.pathname.split('/');
  const query = new URLSearchParams(window.location.search);

  if (!householdId) {
    householdId = pathItems[3];
  }

  if (!portfolioId) {
    portfolioId = query.get('portfolioId');
  }

  return (
    <SubNav
      items={[
        {
          isActive: true,
          isAvailable: false,
          label: "Digital Onboarding",
          path: ``,
        },
      ]}
      open={open}
      pathname={pathname}
      suffix={
        <React.Fragment>
          {(predecessorPortfolioId || successorPortfolioId) && (
            <PortfolioHistoryModal
              dialogAnchorComponent={
                <span className={`${classes.bottomLink} history`}>HISTORY</span>
              }
              portfolioId={portfolioId}
              householdId={householdId}
            />
          )}
          <DisclosureModal
            dialogAnchorComponent={
              <span className={`${classes.bottomLink} disclosure`}>
                DISCLOSURES
              </span>
            }
          />
          <BackToHousehold householdId={householdId} />
        </React.Fragment>
      }
    />
  );
}

const mapStateToProps = (state, props) => {
  return {
    app: state.app,
    currentPortfolio: state.portfolio.currentPortfolio,
  };
};
export default withRouter(withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(DoNavigation)
));



// WEBPACK FOOTER //
// ./src/containers/Cy/components/DoNavigation/index.jsx